import { contrastRatio } from '@yola/yola-palette-generator';
import increaseColorPointByRatio from '../../../common/utils/increase-color-point-by-ratio';
import reduceColorPointByStep from '../../../common/utils/reduce-color-point-by-step';
import reduceOpacity from '../../../common/utils/reduce-opacity';

const condition = (ratio) => ratio <= 2;

const dark = (params) => {
  const { errorColorPalette, backgroundColor } = params;
  const fallback = {
    rule: 'focusBorder.error.dark',
    params,
  };
  if (condition(contrastRatio(backgroundColor, errorColorPalette[900]))) {
    const calculatedColor = increaseColorPointByRatio(
      {
        targetColor: errorColorPalette[50],
        backgroundColor,
        targetColorPalette: errorColorPalette,
        condition,
        fallback,
      },
      '50'
    );

    return reduceColorPointByStep({
      targetColor: calculatedColor,
      targetColorPalette: errorColorPalette,
      step: 1,
      fallback,
    });
  }

  const calculatedColor = reduceOpacity({
    targetColor: errorColorPalette[900],
    backgroundColor,
    opacity: 0.99,
    condition,
    fallback,
  });

  if (calculatedColor.getAlpha() < 1) {
    calculatedColor.setAlpha(calculatedColor.getAlpha() + 0.01);
  }
  return calculatedColor;
};

export default dark;
